import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormularioExtendedDto, PreguntaExtendedDto, RespuestaExtendedDto } from './client';

@Injectable()
export class ControlPreguntasService {
	constructor() { }

	toFormGroup(preguntas: PreguntaExtendedDto[]) {
		const group: any = {};

		preguntas.forEach(pregunta => {
			group['pregunta_' + pregunta.id] = new FormControl('', Validators.required);
		});

		return new FormGroup(group);
	}

	toRespuestaFormGroup(formulario: FormularioExtendedDto, respuestasDto: RespuestaExtendedDto) {

		const preguntasGroup: any = {};
		const respuestasGroup: any = {};

		// Map repuestas
		const respuestas = respuestasDto.respuestaPregunta;
		respuestas.forEach(respuesta => {
			respuestasGroup[respuesta.pregunta.id]
				= !!respuesta.opciones[0] ? respuesta.opciones[0].id.toString() :
					(!!respuesta.contestacion ? respuesta.contestacion.toString() : '');
		});

		formulario.preguntas.forEach(pregunta => {
			preguntasGroup['pregunta_' + pregunta.id]
				= new FormControl(!!respuestasGroup[pregunta.id] ? respuestasGroup[pregunta.id] : '', Validators.required);
		});

		return new FormGroup(preguntasGroup);
	}
}
